import styled from 'styled-components';

export const Container = styled.div<{ isFacelift: boolean }>`
  margin-top: 0.5rem;

  & > div:nth-child(-n + 2) {
    width: ${({ isFacelift }) => (isFacelift ? '100%' : '97%')};
    margin: auto;
    max-width: ${({ theme, isFacelift }) =>
      isFacelift ? '100%' : theme.breakpoints.laptopL};
    padding-bottom: 1rem;
  }
`;
